import { QueryClient } from '@tanstack/react-query';
import { isForbiddenError } from '@/components/forbidden/is-forbidden-error';

export default new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // A 403 is a permission decision, never transient — retrying only delays the section's
      // graceful empty/forbidden state (and stalls `isPending`). Other errors retry once, as before.
      retry: (failureCount, error) => !isForbiddenError(error) && failureCount < 1,
    },
  },
});
